import {useState} from 'react';
import Icon, {ICONS} from 'patient-ping-remedy/packages/icon';
import {colors} from 'patient-ping-remedy/packages/theme';
import {AdditionalEvent, resolveAdditionalEventDataTypeLabel} from '@/api/dto/care-journey';
import {buildTriggeredByText} from '@/helpers/additional_event_helpers';
import {
  Body,
  Chevron,
  CountBadge,
  DateSegment,
  EventCard,
  HeaderButton,
  HeaderLeft,
  LeadIn,
  Row,
  TealContainer,
  TypeSegment,
  ViewNotesButton,
  ViewNotesSegment,
} from '@/components/pages/tasks/task_edit/progress/AdditionalEventsBanners.styles';

type Props = {
  additionalEvents?: AdditionalEvent[];
  onViewNotes?: (event: AdditionalEvent) => void;
};

const BODY_ID = 'additional-events-body';

export default function AdditionalEventsBanners({additionalEvents, onViewNotes}: Props) {
  const [isExpanded, setIsExpanded] = useState(true);

  if (!additionalEvents || additionalEvents.length === 0) {
    return null;
  }

  const leadIn = `${additionalEvents.length} additional event(s) recorded and merged here.`;

  return (
    <TealContainer>
      <HeaderButton
        type="button"
        aria-expanded={isExpanded}
        aria-controls={BODY_ID}
        onClick={() => setIsExpanded((prev) => !prev)}
      >
        <HeaderLeft>
          <Icon iconClass={ICONS['clinic-medical']} iconSize="2x" weight="fal" color={colors.teal5} />
          <LeadIn>{leadIn}</LeadIn>
        </HeaderLeft>
        <Chevron aria-hidden="true">
          <Icon iconClass={isExpanded ? ICONS['angle-up'] : ICONS['angle-down']} iconSize="lg" />
        </Chevron>
      </HeaderButton>

      {isExpanded && (
        <Body id={BODY_ID}>
          {additionalEvents.map((event) => {
            const typeLabel = resolveAdditionalEventDataTypeLabel(event.dataType);
            const triggeredBy = buildTriggeredByText(event);

            return (
              <EventCard key={event.id}>
                <Row>
                  {typeLabel && <TypeSegment>{typeLabel}</TypeSegment>}
                  {typeLabel && ' '}
                  <DateSegment>{triggeredBy}</DateSegment>
                  <ViewNotesSegment>
                    {event.noteCount > 0 && (
                      <CountBadge>{event.noteCount}</CountBadge>
                    )}
                    <ViewNotesButton
                      type="button"
                      data-note-thread-id={event.noteThreadId ?? undefined}
                      onClick={() => onViewNotes?.(event)}
                    >
                      View note(s)
                    </ViewNotesButton>
                  </ViewNotesSegment>
                </Row>
              </EventCard>
            );
          })}
        </Body>
      )}
    </TealContainer>
  );
}
